// extracted by mini-css-extract-plugin
export default {"searchWrapper":"search-input_searchWrapper__UpcpT","search":"search-input_search__mGtL4","searchWrapperWithSuffix":"search-input_searchWrapperWithSuffix__7+p8q"};